import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VerificationRoutingModule } from './verification-routing-module';
import { VerificationSummary } from './verification-summary/verification-summary';
import { VerificationForm } from './verification-form/verification-form';
import { CanonForm } from './canon-form/canon-form';
import { SharedModule } from '../../shared/shared-module';
import { VerificationList } from './verification-list/verification-list';
import { AuditList } from './audit-list/audit-list';
import { CanonSearchDialog } from './canon-search-dialog/canon-search-dialog';
import { CanonList } from './canon-list/canon-list';
import { VerificationHistory } from './verification-history/verification-history';
import { VerificationHistoryDetails } from './verification-history-details/verification-history-details';


@NgModule({
  declarations: [
    VerificationSummary,
    VerificationForm,
    CanonForm,
    VerificationList,
    AuditList,
    CanonSearchDialog,
    CanonList,
    VerificationHistory,
    VerificationHistoryDetails
  ],
  imports: [
    CommonModule,
    SharedModule,
    VerificationRoutingModule
  ],
  exports:[
    VerificationSummary,
    VerificationForm,
    CanonForm,
    VerificationList,
    AuditList,
    CanonSearchDialog,
    CanonList,
    VerificationHistory,
    VerificationHistoryDetails
  ]
})
export class VerificationModule { }
